var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aweber-callback"},[(_vm.loading)?_c('p',[_vm._v("Processing your AWeber integration...")]):_vm._e(),(_vm.error)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }